import { useState, useEffect, useCallback } from 'react'

declare const __APP_VERSION__: string

const POLL_INTERVAL = 5 * 60 * 1000 // 5 minutes

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  const checkVersion = useCallback(async () => {
    try {
      const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) return
      const { version } = await res.json()
      if (version && version !== __APP_VERSION__) {
        setUpdateAvailable(true)
      }
    } catch {
      // Network error - ignore silently
    }
  }, [])

  useEffect(() => {
    // Poll on visibility change (user switches back to tab)
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkVersion()
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    // Poll on interval as fallback
    const interval = setInterval(checkVersion, POLL_INTERVAL)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      clearInterval(interval)
    }
  }, [checkVersion])

  const reload = useCallback(() => {
    window.location.reload()
  }, [])

  return { updateAvailable, reload }
}
